import type { CalculatedAttributesCollector } from '../../calculatedAttributes/collect';

/**
 * Only what the collector reads — the block's mapper-typed component lives in
 * the host app.
 */
type MiniProductHighlightForCollection = {
  id: string;
  product?: { title?: string | null } | null;
  attribute?: { name?: string | null } | null;
  mini_product_highlight_attribute_list?: Array<{
    attribute?: { name?: string | null } | null;
  } | null> | null;
};

/**
 * The block shows one product against an editor-chosen list of attributes
 * (CMS-1890) — one product, one group.
 *
 * The block has no mode, so it states no vertical and the page's stands in.
 */
export const collectMiniProductHighlightCalculatedAttributes: CalculatedAttributesCollector<
  MiniProductHighlightForCollection
> = (component) => {
  const productId = component.product?.title;
  if (!productId) return undefined;

  // The list wins when it has entries; the single `attribute` is the older
  // shape and stands in for it otherwise — the block resolves it exactly this
  // way, and concatenating the two instead would report an attribute the block
  // never renders. That is not inert: the loan-filter slot is placed from these
  // requests, so the widget would mount beside a block that shows no figure.
  const listed = (component.mini_product_highlight_attribute_list ?? [])
    .filter((item) => !!item?.attribute)
    .map((item) => item?.attribute?.name);
  const attributeNames =
    listed.length > 0 ? listed : [component.attribute?.name];

  return { groups: [{ productIds: [productId], attributeNames }] };
};
